
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection, LabelId_$reflection, StorageId_$reflection, CategoryMinimumQuantityId_$reflection } from "../../../Shared/Shared.js";
import { union_type, class_type, list_type, record_type, int32_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Label_$reflection, DTO_CategoryDetailsDto_$reflection } from "../../../Shared/Category.js";

export class StorageTableRow extends Record {
    constructor(CategoryMinimumQuantityId, StorageId, StorageName, MinimumQuantity) {
        super();
        this.CategoryMinimumQuantityId = CategoryMinimumQuantityId;
        this.StorageId = StorageId;
        this.StorageName = StorageName;
        this.MinimumQuantity = (MinimumQuantity | 0);
    }
}

export function StorageTableRow_$reflection() {
    return record_type("Settings.Categories.Details.Types.StorageTableRow", [], StorageTableRow, () => [["CategoryMinimumQuantityId", CategoryMinimumQuantityId_$reflection()], ["StorageId", StorageId_$reflection()], ["StorageName", string_type], ["MinimumQuantity", int32_type]]);
}

export class State extends Record {
    constructor(CategoryId, Category, AllCategories, FormState) {
        super();
        this.CategoryId = CategoryId;
        this.Category = Category;
        this.AllCategories = AllCategories;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Categories.Details.Types.State", [], State, () => [["CategoryId", LabelId_$reflection()], ["Category", RequestedValue$1_$reflection(DTO_CategoryDetailsDto_$reflection())], ["AllCategories", RequestedValue$1_$reflection(list_type(Label_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteCategory", "FetchCategory", "CategoryDeleted", "CategoryFetched", "CategoriesFetched", "DeleteCategoryMinimumQuantity", "CategoryMinimumQuantityDeleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Categories.Details.Types.Msg", [], Msg, () => [[], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", DTO_CategoryDetailsDto_$reflection()]], [["Item", list_type(Label_$reflection())]], [["Item", CategoryMinimumQuantityId_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

